import script from "./ViewAllTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllTemplates.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllTemplates.vue?vue&type=style&index=0&id=242430ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242430ec"]])

export default __exports__